export const checklistOptions = [
  { label: "Puhelinnumero", englishLabel: "Phone number", value: "phone" },
  { label: "Sähköpostiosoite", englishLabel: "Email address", value: "email" },
  {
    label: "Kotiosoitteesi",
    englishLabel: "Your home address",
    value: "address"
  },
  {
    label: "Aiempi kotiosoitteesi?",
    englishLabel: "Your previous home address?",
    value: "previous-address"
  },
  {
    label: "Henkilötunnuksesi",
    englishLabel: "Your personal identity number",
    value: "personal-number"
  },
  {
    label: "Tilinumerosi, koko IBAN",
    englishLabel: "Your account number, full IBAN",
    value: "account-number"
  },
  {
    label: "Tarkoitus tarkistettu",
    englishLabel: "Purpose verified",
    value: "purpose-checked"
  }
];

export const additionalChecklistOptions = [
  {
    label: "Mikä on huoneistonumerosi?",
    englishLabel: "What is your apartment number?",
    value: "apartment-number"
  },
  {
    label: "Missä kerroksessa asut?",
    englishLabel: "Which floor do you live on?",
    value: "floor"
  },
  { label: "Omistatko auton?", englishLabel: "Do you own a car?", value: "car" }
];

export const insuranceChecklistOptions = [
  {
    label: "Työskenteletkö vähintään 50 % ja onko sinulla vakituinen työsuhde?",
    englishLabel: "Do you work at least 50% and have permanent employment?",
    value: "permanent-employment"
  },
  {
    label:
      "Oletko tietoinen mahdollisesta irtisanomisesta, työkyvyttömyydestä tai sairauspoissaolosta?",
    englishLabel:
      "Are you aware of any possible termination, incapacity for work, or sick leave?",
    value: "termination"
  },
  {
    label: "Kuulutko työttömyyskassaan ja yrittäjien työttömyyskassaan?",
    englishLabel:
      "Are you a member of an unemployment fund and an entrepreneurs' unemployment fund?",
    value: "unemployment-insurance"
  }
];
